// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"180":"2cca2479","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"9801f05a9f2e813efc9e","180":"718e4e9641a160492bf7","245":"72dd752d50a02c85298a","452":"38d7990a3431b09dd4eb","453":"7cd02dccd4ecca744e19"}[chunkId] + ".js";
};